







import {Component, Prop, Vue} from 'vue-property-decorator';
import GoalBooklet from "@/models/goal-booklet";
import GlobalMixin from "@/mixins";

@Component({
    components: {
    },
})
export default class BookletView extends GlobalMixin {

    @Prop()
    public goalid!: string;

    @Prop()
    public id!: string;

    get goalDetails() {
        return this.$store.getters.goalDetailById(this.goalid);
    }


    get goalBooklet(): GoalBooklet|null {

        const goal = this.goalDetails;

        if (goal && goal.details &&
            goal.details.promptGoalBooklets &&
            goal.details.promptGoalBooklets.length) {
            return goal.details.promptGoalBooklets.find((goalBooklet: GoalBooklet) => {
                return goalBooklet.id.toString() === this.id.toString();
            })
        }
        return null;
    }

    get websiteId() {
        return this.$store.state.data ? this.$store.state.data.website_id : '';
    }

    private mounted() {
        this.track('View Booklet', this.goalBooklet ? this.goalBooklet.booklet.name : '', this.goalDetails.goal, this.websiteId);
    }
}
